import React, { useEffect, useRef } from 'react';
import { Html5Qrcode } from 'html5-qrcode';

const QrScannerComponent = ({ onScan }) => {
  const scannerRef = useRef(null);
  const html5QrCodeRef = useRef(null);

  useEffect(() => {
    let mounted = true;
    const startScanner = async () => {
      try {
        if (!scannerRef.current || !mounted) return;
        html5QrCodeRef.current = new Html5Qrcode('qr-reader');
        await html5QrCodeRef.current.start(
          { facingMode: 'environment' },
          { fps: 10, qrbox: { width: 200, height: 200 } },
          (decodedText) => {
            if (mounted) {
              html5QrCodeRef.current?.stop().catch(() => {});
              onScan(decodedText);
            }
          },
          () => {}
        );
      } catch (err) {
        console.log('Camera not available:', err);
      }
    };

    const timer = setTimeout(startScanner, 300);

    return () => {
      mounted = false;
      clearTimeout(timer);
      if (html5QrCodeRef.current) {
        html5QrCodeRef.current.stop().catch(() => {});
      }
    };
  }, [onScan]);

  return (
    <div className="rounded-xl overflow-hidden bg-slate-900">
      <div id="qr-reader" ref={scannerRef} style={{ width: '100%' }} data-testid="qr-camera-view" />
      <p className="text-center text-slate-400 text-xs py-2">Point camera at the QR code</p>
    </div>
  );
};

export default QrScannerComponent;
